
import React from 'react';
import PropTypes from 'prop-types';

const MessageIcon = ({ width, height, fill, stroke }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24.5 16.5">
        <g>
            <g>
                <path d="M21.75 15.75h-19a2 2 0 01-2-2v-11a2 2 0 012-2h19a2 2 0 012 2v11a2 2 0 01-2 2z" fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            </g>
            <g>
                <path d="M2.75 2.75l8.2 5.611a2.3 2.3 0 002.6 0l8.2-5.611" fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            </g>
            <g >
                <path d="M2.75 13.75l6-5" fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            </g>
            <g>
                <path d="M21.75 13.75l-6-5" fill={fill} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            </g>
        </g>
    </svg>

);

MessageIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string,
    stroke: PropTypes.string
};

MessageIcon.defaultProps = {
    width: '24.5',
    height: '16.5',
    fill: 'none',
    stroke: '#4b254e'
};

export default MessageIcon;
